<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Vendas">
      <b-row class="mb-5">
        <b-col cols="12" sm="7" class="mb-2">
          <Search @changeSearchValue="searchValue = $event" />
        </b-col>
        <b-col>
          <b-row class="justify-content-end mr-1">
            <b-col cols="auto">
              <b-button
                variant="outline-secondary"
                class="mr-3"
                @click="goToNewSale()"
              >
                <b-icon icon="plus-circle-fill"></b-icon> Adicionar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <Estoque />
      <Pedidos :searchValue="searchValue" />
    </Dashboard>
  </div>
</template>

<script>
import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import Search from '../components/Search.vue';
import Sidebar from '../components/Sidebar.vue';
import Estoque from '../components/sale/Estoque.vue';
import Pedidos from '../components/sale/Pedidos.vue';

export default {
  components: { HeaderVue, Sidebar, Dashboard, Search, Estoque, Pedidos },
  data() {
    return {
      searchValue: '',
    };
  },
  methods: {
    goToNewSale() {
      this.$router.push('/nova-venda');
    },
  },
};
</script>

<style scoped></style>
